"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type React from "react";
import { useActionState } from "react";
import { signup } from "@/actions/auth";
import { Logo } from "@/components/logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
export function SignupForm(t0) {
  const $ = _c(39);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      full: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const full = t1 === undefined ? false : t1;
  const [signupState, signupAction, signupPending] = useActionState(signup, undefined);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-8 w-8 items-center justify-center rounded-md"><Logo size="sm" /></div>;
    t3 = <h1 className="text-xl font-extrabold">Crea una cuenta</h1>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = !full;
  let t5;
  if ($[6] !== full) {
    t5 = e => {
      if (full) {
        e.preventDefault();
        window.location.href = "/login";
      }
    };
    $[6] = full;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex flex-col items-center gap-2">{t2}{t3}<div className="text-center text-sm">¿Ya tienes una cuenta?{" "}<Link href="/login" replace={t4} onNavigate={t5} className="underline underline-offset-4">Inicia sesión</Link></div></div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Label htmlFor="name">Nombre</Label>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = signupState?.values.name ?? "";
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="grid gap-2">{t7}<Input id="name" name="name" type="text" placeholder="Nombre" autoComplete="name" autoFocus={true} defaultValue={t8} required={true} /></div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== signupState) {
    t10 = signupState?.errors.name && <p className="text-destructive-foreground text-sm">{signupState.errors.name}</p>;
    $[14] = signupState;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Label htmlFor="email">Correo electrónico</Label>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = signupState?.values.email ?? "";
  let t13;
  if ($[17] !== t12) {
    t13 = <div className="grid gap-2">{t11}<Input id="email" name="email" type="email" placeholder={"Correo electr\xF3nico"} autoComplete="username" autoCapitalize="none" defaultValue={t12} required={true} /></div>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== signupState) {
    t14 = signupState?.errors.email && <p className="text-destructive-foreground text-sm">{signupState.errors.email}</p>;
    $[19] = signupState;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== signupPending) {
    t15 = <Button type="submit" disabled={signupPending} className="w-full">Registrarse</Button>;
    $[21] = signupPending;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== signupState) {
    t16 = signupState?.errors.global && <p className="text-destructive-foreground text-sm">{signupState.errors.global}</p>;
    $[23] = signupState;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t10 || $[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== t16 || $[30] !== t9) {
    t17 = <div className="flex flex-col gap-6">{t9}{t10}{t13}{t14}{t15}{t16}</div>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t9;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17 || $[33] !== t6) {
    t18 = <form action={signupAction}><div className="flex flex-col gap-6">{t6}{t17}</div></form>;
    $[32] = t17;
    $[33] = t6;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== className || $[36] !== props || $[37] !== t18) {
    t19 = <div className={className} {...props}>{t18}</div>;
    $[35] = className;
    $[36] = props;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
}